import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { createSelector } from 'reselect'
import { withCenteredBaseWithMenu } from '../../components/Base'
import SetupMFA from '../../pages/SetupMFA'
import { getUser } from '../../selectors/initialization'
import { getShouldSetupMFA, getMfaState } from '../../selectors/settings'
import { SETUP_WEB_AUTHN, SETUP_TOTP } from '../../constants/routes'

export const mapStateToProps = createSelector(
  [getUser, getShouldSetupMFA, getMfaState],
  (user, shouldSetupMFA, mfaState) => ({
    user,
    displayLogoutMenuOnly: shouldSetupMFA,
    enabledMFAMechanisms: mfaState.enabledMFAMechanisms,
    hasAllMFAEnabled: mfaState.hasAllMFAEnabled
  })
)

export const mapDispatchToProps = (dispatch, ownProps) => ({
  onSetupWebAuthn: () =>
    dispatch(
      push(SETUP_WEB_AUTHN, ownProps.location && ownProps.location.state)
    ),
  onSetupTOTP: () =>
    dispatch(push(SETUP_TOTP, ownProps.location && ownProps.location.state))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCenteredBaseWithMenu(SetupMFA))
